import React, { useEffect, useState } from 'react';

import './dropdown.scss';
let classNames = require('classnames');

const Dropdown = ({ customClass, list, selected, onChange, DropDownTitle }) => {
  const [isOpen, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(selected?.id);

  const handleItemClick = (e) => {
    const id = e.target.id;
    const listItem = list.find(obj => obj.id.toString() === id);
    if (typeof (listItem) !== 'undefined' && typeof (listItem?.link) !== 'undefined') {
      setOpen(!isOpen);
      selectedItem == id ? setSelectedItem() : setSelectedItem(id);
      window.location.href = listItem?.link;
    } else {
      selectedItem == id ? setSelectedItem() : setSelectedItem(id);
      setOpen(!isOpen);
      if (onChange) {
        onChange(listItem);
      }
    }
  };

  useEffect(() => {
    list.find(a => a === selected) && setSelectedItem(list.find(a => a === selected)?.id);
  }, [list]);

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick, false);
    return () => {
      document.removeEventListener('click', handleOutsideClick, false);
    };
  }, []);

  const handleOutsideClick = (e) => {
    if (e.target.closest('.dropdown')) {
      return;
    }
    setOpen(false);
  };

  return (
    <div className={classNames(['dropdown', customClass])}>
      <label>{DropDownTitle}</label>
      <div className='dropdown-header' onClick={() => setOpen(!isOpen)} tabIndex={0}>
        <div className={`dropdown-selected ${isOpen && 'open'}`} aria-haspopup="listbox" aria-labelledby="exp_elem exp_button_dropdown">
          {selectedItem ? list.find(item => item.id == selectedItem)?.label : list[0]?.label}
        </div>
        <div className={`icon ${isOpen && 'open'}`}></div>
      </div>
      <ul className={`dropdown-body ${isOpen && 'open'}`} id={`exp_elem_list_dropdown`} role="listbox" aria-labelledby="exp_button_dropdown">
        {list.map(item => (
          <li key={item.id} id={item.id} className="dropdown-item" onClick={handleItemClick} tabIndex={`${isOpen ? '0' : '-1'}`} role="option">
            <span className={`dropdown-item-dot ${item.id == selectedItem && 'selected'}`}></span>
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

Dropdown.defaultProps = {
  customClass: 'dropdown',
};

export default Dropdown;
